import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import './Header.css';
import { useNavigate } from 'react-router-dom';
import { TKModelContext } from '../../context/TKModelContext';
import { updateTechnologicalCardName } from '../../../../api/enterprise';

const Header = ({ enterpriseId }) => {
  const navigate = useNavigate();
  const { serverData } = useContext(TKModelContext);

  const [name, setName] = useState("");


  const handleOpenTechnologicalCards = () => {
    navigate(`/${enterpriseId}/directory/technology-card`);
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
  }

  const handleFetchChangedName = useCallback(() => {
    updateTechnologicalCardName(serverData?.product_sheet_id, name)
  }, [name, serverData?.product_sheet_id])


  useEffect(() => {
    if (serverData?.name) {
      setName(serverData.name)
    }
  }, [serverData?.name])


  return (
    <div className="header">
      <button onClick={handleOpenTechnologicalCards}>Назад</button>
      <input type="text" value={name} onChange={handleNameChange} onBlur={handleFetchChangedName} />
    </div>
  );
};

export default Header;